import React, { useEffect, useState, useMemo } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import InlineTextField from "../../Components/InLineTextField"
import { useHistory } from "react-router-dom"
import { FaCircleCheck, FaPen, FaPlus } from "react-icons/fa6"
import { RiCloseCircleFill } from "react-icons/ri"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)

const Plans = () => {

    const [planList, setPlanList] = useState([])
    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [page, setPage] = useState(0)
    const history = useHistory()
    const dispatch = useDispatch()
    const [count, setCount] = useState(0)

    useEffect(() => {
        setLoading(true)
        try {
            API.get('/plans/getAllPlans').then((planRes) => {
                if (planRes.status === 200) {
                    setPlanList(planRes.data.data)
                    setLoading(false)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }, [count])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        { name: 'Plan Name', selector: row => row.planName, initialActive: true, sortable: true },
        { name: 'Plan Rate', selector: row => row.planRate, sortable: true },
        { name: 'Plan Validity', selector: row => row.planValidity, sortable: true },
        { name: 'Download Limit', selector: row => row.downloadLimit, sortable: true },
        { name: "Benefits", selector: row => row.planBenefits.length, sortable: true },
        { name: 'View', selector: row => row.viewAble ? 'On' : 'Off', initialActive: true, sortable: true },
        {
            name: 'Action', selector: row => <motion.div className="relative flex flex-row w-full justify-between">
                {row.viewAble === false && <FaCircleCheck color="green" className="mx-2 cursor-pointer" onClick={() => activatePlans(row)} />}
                {row.viewAble === true && <RiCloseCircleFill color="red" className="mx-2 cursor-pointer" onClick={() => deactivatePlans(row)} />}
                <motion.div className="mx-2 text-[indigo] cursor-pointer" onClick={() => history.push(`/editPlan/${row._id}`)}>
                    <FaPen title="Category edit" />
                </motion.div>
            </motion.div>, initialActive: true, sortable: true
        }
    ], [])
    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ')
        return planList.filter(c =>
            filterSplit.every(i =>
                Object.keys(c).some(j => c[j]?.toString().toLowerCase().includes(i))
            )
        )
    }, [planList, filter])

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => history.push(`/createPlan`)}><FaPlus /></motion.div>
        </div>
    ), [filter])// eslint-disable-line

    const activatePlans = (values) => {
        API.post('/plans/activate', values).then((apiRes) => {
            if (apiRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitlte: "Plan Activated successfully", active: true, type: 'success' }))
                setCount(count + 1)
            }
        })
    }

    const deactivatePlans = (values) => {
        API.post('/plans/deactivate', values).then((apiRes) => {
            if (apiRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitlte: "Plan Deactivated successfully", active: true, type: 'success' }))
                setCount(count + 1)
            }
        })
    }

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                    <DataTable
                        title="Plan List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            {/* <Dialog injectClass={'min-w-screen'} showDialog={openEditModal} title={'Edit User'} onClose={() => setOpenEditModal(false)}>
                <PreviewUser registerValues={userId} onClose={() => setOpenEditModal(false)} />
            </Dialog> */}
            {/* <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={'Deactivate User'} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to deactivate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={'Activate User'} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog> */}
        </motion.div>
    )
}

export default Plans